/* eslint-disable react/prop-types */
import React from 'react'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'

/* Component for the expandable Rows on the table,
to show more data about the ticket
Input: props */

export default function ExpandedRowDeviceView (props) {
  return (
    <TableRow style={{ background: 'white' }}>
      <TableCell style={{ padding: '1rem' }}
        colSpan={props.rowDataLength}>
        {props.devices}
      </TableCell>
    </TableRow>
  )
}
